import axios from './axios';

export default class SectionUnit {
  static destroy(_, unit, sectionId) {
    return axios.delete(`/paths/units/${unit.id}?section_id=${sectionId}`).then(response => response.data);
  }
}
